import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Data } from 'src/app/helper/datastore';
import { WebRequestService } from 'src/app/services/web-request.service';
import { LoaderComponent } from '../../builders/loader/loader.component';
import * as moment from 'moment';
import { Router } from '@angular/router';
@Component({
  selector: 'view-ticket-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent implements OnInit, OnChanges {
 // @ViewChild('myModal', { static: false }) modal: ElementRef;
 @Input() isModalShow: any;
 @Input() ticketId: any;
 @Output() closeTicketModal = new EventEmitter()
 @ViewChild('viewTicketModal')
 private viewTicketModal: any;
 @ViewChild('basicModal')
 private basicModal: any;
 @ViewChild('successModal')
 private successModal: any;
 @ViewChild('contactViewModal')
 private contactViewModal: any;
 ticketViewTab: any = 1;
 incomingCallForm: FormGroup;
 outGoingCallForm: FormGroup;
 otpForm: FormGroup;
 internalMemoForm: FormGroup;
 closeTicketForm: FormGroup;
 LoaderComponent: any = '';
 remainderDateTime: any = "";
 remainderId: any = "";
 tracking:boolean=false;
 callReasonArray:any = [];
 cancdidateContactDetails: any = [];
 typeOfViewContact: string;
 callsFrom: any = [
  { "label": "Father", "title": "Father", "value": 39 },
  { "label": "Mother", "title": "Mother", "value": 40 },
  { "label": "YoungerBrother", "title": "YoungerBrother", "value": 41 },
  { "label": "ElderBrother", "title": "ElderBrother", "value": 42 },
  { "label": "Self", "title": "Self", "value": 283 },
  { "label": "YoungerSister", "title": "YoungerSister", "value": 321 },
  { "label": "ElderSister", "title": "ElderSister", "value": 322 },
  { "label": "FatherYoungerBrother", "title": "FatherYoungerBrother", "value": 323 },
  { "label": "FatherElderBrother", "title": "FatherElderBrother", "value": 324 },
  { "label": "FatherYoungerSister", "title": "FatherYoungerSister", "value": 325 },
  { "label": "FatherElderSister", "title": "FatherElderSister", "value": 326 },
  { "label": "MotherYoungerBrother", "title": "MotherYoungerBrother", "value": 327 },
  { "label": "MotherElderBrother", "title": "MotherElderBrother", "value": 328 },
  { "label": "MotherYoungerSister", "title": "MotherYoungerSister", "value": 329 },
  { "label": "MotherElderSister", "title": "MotherElderSister", "value": 320 },
  { "label": "Spouse", "title": "Spouse", "value": 334 },
  { "label": "XRelation", "title": "XRelation", "value": 554 },
  { "label": "GrandFather", "title": "GrandFather", "value": 556 },
  { "label": "GrandMother", "title": "GrandMother", "value": 557 },
  { "label": "SisterHusband", "title": "SisterHusband", "value": 558 },
  { "label": "Friend", "title": "Friend", "value": 559 },
  { "label": "Relative", "title": "Relative", "value": 560 },
  { "label": "Uncle", "title": "Uncle", "value": 561 },
  { "label": "Aunt", "title": "Aunt", "value": 562 }
];

voiceCallsType: any =  [
  { "label": "--Select--", "title": "--Select--", "value": "" },
  { "label": "Whatsapp call", "title": "Whatsapp call", "value": 589 },
  { "label": "Mobile call", "title": "Mobile call", "value": 590 },
  { "label": "Land call", "title": "Land call", "value": 591 },
  { "label": "Magic Jack", "title": "Magic Jack", "value": 592 },
  { "label": "Whatsapp Message", "title": "Whatsapp Message", "value": 593 },
  { "label": "Mobile Message", "title": "Mobile Message", "value": 594 }
];

callTelephoneNumbers: any = [];
assignReassignArray: any = [];
replyTypeArray: any = [];

basicTicketInformation: any  = {}
isSelectedToSendOTP: any =false;
radioStatus: any = false;
noDataList: any =[];
profileId: any = "";
relationExpressInterstFlag = 3;
ticketHistoryList: any = [];
isRemainderActive: any = false;
incomingVoiceCallTypeValue: any ="";
incomingCallRelationId: any = "";
outgoingVoiceCallTypeValue: any = "";
outGoingCallRelationId: any = "";
internalMemoEmpID: any = "";
modifiedId: any = "";
empId: any ="";
userName: any = "";
loggedInUserName: any = "";
responseMessage: any ="";
custId: any = "";
responseVerificationCode: any ="";
previewImgArray: any =[];
isPreviewClicked: any = false;
responseTypeArray:any = [];
loginData: any;
@ViewChild('reasonModal')
reasonModal:any;
reasonForm: FormGroup;
viewContactOrEmailObj:any;
numberAfterReason:any;
isAccessObj:any;
showMobileOrEmail: boolean = false;
 constructor(public service: WebRequestService, private data: Data, public router: Router) {
   }
  ngOnChanges(): void {
    if(this.isModalShow){
      this.loadBasicForms();

      if(this.ticketId){
        this.ticketId += ''+'X';
          this.modifiedId= this.ticketId.replace(/\D/g, "")
          this.LoaderComponent = LoaderComponent;
        this.service.getTicketInformation(this.modifiedId,'I').then((response)=>{
           if(response['statusCode']===200){
            this.LoaderComponent = '';
            if( response['result'].length > 0){
              this.basicTicketInformation = response['result'][0];
              this.custId =  this.basicTicketInformation['Cust_ID']
              this.remainderDateTime = this.basicTicketInformation['ReminderDate']!=null?this.basicTicketInformation['ReminderDate']:'';
              this.remainderId = this.basicTicketInformation['ReminderID']!=null?this.basicTicketInformation['ReminderID']:'';
              this.populateNoData(response['result'][0])
              this.populateTelephoneNumbers(response['result'][0])
              this.profileId = response['result'][0]['ProfileID']
              if(this.loginData['employeeID'] === this.basicTicketInformation['EmpID'] || this.loginData['isManagement'] === 1){
                this.tracking = true;
              } else {
                this.tracking = false;
              }
              this.service.getTicketInformation(this.modifiedId,'H').then((history)=>{
                if(history['statusCode']===200){
                  this.ticketHistoryList = history['result'];
                }
              })
              this.viewTicketModal.show();
            }
           }
        })
        this.service.getResponseTypeData().then((response) => {
          if (response['statusCode'] === 200) {
            this.responseTypeArray = response['result'];
          }

        })
      }

    }
  }

  viewEmailOrMobile(type, number,custID,RM1){

    this.getContatcDetailsInfo(custID);
    this.typeOfViewContact = type;
    this.numberAfterReason = number;
      this.isAccessObj = {
        custID: custID,
        viewCount:1,
        pageType: 11
      }
      this.viewContactOrEmailObj = {
        custID: custID,
        pageName: 'Marketing Slideshow',
        profileOwnerID: RM1,
        section: 'Marketing Slideshow',
        viewType: 'View',
        ContactType: 614,
        IPAddress: this.loginData.ipAddress
      }
      this.reasonModal.show()
  }

  reasonToView(event){
    this.viewContactOrEmailObj.reason  = this.reasonForm.value['reason'].value;
    this.service.viewOtherContactAccess(this.isAccessObj).then((res)=>{
      this.reasonModal.hide();
      if(res['statusCode'] === 200){
        if (res['result'][0].IsContactVisibleAccess) {
          this.service.viewContactOrEmailForOtherEmp(this.viewContactOrEmailObj).then((response)=>{
            this.responseMessage = this.numberAfterReason;
            this.typeOfViewContact == 'call' ? this.contactViewModal.show() : this.successModal.show();
          })
        } else {
          this.reasonModal.hide();
          this.responseMessage = res['result'][0].IsConfidentialProfile ? "You have reached maximum limit to view contacts. Please Contact Naveena and Team" : "You have reached maximum limit to view contacts. Please Contact Siva Prasad and Team";
          this.successModal.show();
        }
      } else {
        this.responseMessage = "Please Try Again Later"
        this.successModal.show()
      }
    })
    this.reasonForm.patchValue({
      reason: ''
    })
  }
  closeReasonDialog(){
    this.showMobileOrEmail = false;
    this.reasonModal.hide()
    this.reasonForm.patchValue({
      reason: ''
    })
  }


  getContatcDetailsInfo(custId) {
    this.LoaderComponent = LoaderComponent;
    this.service.getContacts(custId,true).then((res) => {
      if (res['statusCode'] === 200) {
        this.LoaderComponent = '';
        // console.log('all data',res['result'])
        this.cancdidateContactDetails = res['result'][0]
      } else {
        alert("something worng with API's response")
      }
    })
  }
  changeTab(index){

    if(index == 2 || index == 3){
      this.incomingCallForm.reset();
      this.outGoingCallForm.reset();
      this.incomingCallForm.controls['relationName'].setValue("");
      this.incomingCallForm.controls['voiceCallType'].setValue("");
      this.incomingCallForm.controls['phoneNum'].setValue("");
      this.incomingCallForm.controls['callDiscussion'].setValue("");
      this.outGoingCallForm.controls['relationName'].setValue("");
      this.outGoingCallForm.controls['voiceCallType'].setValue("");
      this.outGoingCallForm.controls['phoneNum'].setValue("");
      this.outGoingCallForm.controls['callDiscussion'].setValue("");
    } else if(index==4) {
      this.getAssignAndReAssignData()
    } else if(index==5) {
      this.getReplyTypeDetails();
    }

    this.ticketViewTab = index;

  }

  getAssignAndReAssignData(){
    this.service.getAssignReAssignData(2,'EmapName').then((response)=>{
        this.LoaderComponent = LoaderComponent;
        if(response['statusCode']===200){
          this.LoaderComponent = "";
          this.assignReassignArray = response['result']?response['result']:[]
        }
    })
  }
  getReplyTypeDetails(){
    this.service.getReplyTypeData('Market_replytype','ID: ','RelationShipID:'+' ').then((response)=>{
      this.LoaderComponent = LoaderComponent;
      if(response['statusCode']===200){
        this.LoaderComponent = "";
        this.replyTypeArray = response['result']?response['result']:[]
      }
    })
  }
createRemainder(){
  this.isRemainderActive = true;
}

 ngOnInit(): void {
  this.loadBasicForms();
  this.service.loadMasterData('ClickToCallReason').then((res) => {
    if (res['statusCode'] === 200) {
      this.callReasonArray = res['result'];

    }
  }).catch((err) => { console.log(err) })

  this.reasonForm = new FormGroup({
    reason: new FormControl(null, [Validators.required])
  })
 }

 loadBasicForms(){

   this.radioStatus= false
  this.otpForm = new FormGroup({
    otp1: new FormControl(null, [
      Validators.required,
      Validators.maxLength(1),
      Validators.pattern('^[0-9]{1,1}$'),
    ]),
    otp2: new FormControl(null, [
      Validators.required,
      Validators.maxLength(1),
      Validators.pattern('^[0-9]{1,1}$'),
    ]),
    otp3: new FormControl(null, [
      Validators.required,
      Validators.maxLength(1),
      Validators.pattern('^[0-9]{1,1}$'),
    ]),
    otp4: new FormControl(null, [
      Validators.required,
      Validators.maxLength(1),
      Validators.pattern('^[0-9]{1,1}$'),
    ]),
    otp5: new FormControl(null, [
      Validators.required,
      Validators.maxLength(1),
      Validators.pattern('^[0-9]{1,1}$'),
    ]),
  });
    this.incomingCallForm = new FormGroup({

      relationID: new FormControl('', [
        Validators.required,
      ]),
      voiceCallType: new FormControl('', [
        Validators.required,
      ]),
      relationName: new FormControl('', [
        Validators.required,
      ]),
       phoneNum: new FormControl('',[
        Validators.required,
      ]),
      callDiscussion: new FormControl('', [
        Validators.required,
      ]),
      MarketingTicketStatus: new FormControl('')
    });
    this.outGoingCallForm =  new FormGroup({
      relationID: new FormControl('', [
        Validators.required,
      ]),
      voiceCallType: new FormControl('', [
        Validators.required,
      ]),
      callResult: new FormControl('',[
        Validators.required,
      ]),
      relationName: new FormControl('', [
        Validators.required,
      ]),
      phoneNum: new FormControl('',[
        Validators.required,
      ]),
      callDiscussion: new FormControl('', [
        Validators.required,
      ]),
      MarketingTicketStatus: new FormControl('')
    })

    this.internalMemoForm = new FormGroup({
      assignReAssign: new FormControl('', [
        Validators.required,
      ]),
      memo: new FormControl('', [
        Validators.required,
      ]),
    })

    this.closeTicketForm = new FormGroup({
      replyType : new FormControl('',[
        Validators.required,
      ]),
      reasonForClose : new FormControl('',[
        Validators.required
      ])
    })
    this.data.getStoreData('empData')
    .then((dataRes: any) => {
      this.loginData = JSON.parse(dataRes);
      this.empId = JSON.parse(dataRes).employeeID;
      this.loggedInUserName = JSON.parse(dataRes).firstName
    })
   if(this.router.url.includes('registrationprofile')){
    this.outGoingCallForm.controls.phoneNum.clearValidators();
    this.outGoingCallForm.controls.phoneNum.updateValueAndValidity();
    this.incomingCallForm.controls.phoneNum.clearValidators();
    this.incomingCallForm.controls.phoneNum.updateValueAndValidity();
  }
 }
 showImagePreview(id){
  this.service.getTicketPhotos(id).then((response)=>{
    if (response['statusCode'] === 200) {
      if (response['result'].length > 0) {
        this.previewImgArray = response['result'];
        this.isPreviewClicked = true;
      } else {
        this.isPreviewClicked = false;
      }
    } else {
    }
  })
 }
 closeModalPreviewImage(data){
  this.isPreviewClicked = false;
 }

 populateNoData(responseData){
   this.noDataList = (responseData['NoDatafound']!="" && responseData['NoDatafound']!=null)?responseData['NoDatafound'].trim().split(","):[]
 }

 populateTelephoneNumbers(response){
   this.callTelephoneNumbers = (response['FatherCon']!="" && response['FatherCon']!=null)?response['FatherCon'].trim().split(','):[]
 }

 selectedIncomingTelePhone(value){
  if(value && value!=""){
    let actualValue = value.split(' ');
    this.incomingCallForm.controls['phoneNum'].setValue(actualValue[1]);
  }
 }

 submitIncomingForm(formValue, assignMe){
    let formObject  = this.prepareIncomingFormObject('incomingCall',formValue, assignMe);
   this.service.saveIncomingCall(formObject).then((response)=>{
     this.LoaderComponent = LoaderComponent;
     if(response['statusCode']===200){
      this.LoaderComponent  = "";
        this.savedTicketRefreshHistory()
     }
   })
 }

 submitOutGoingForm(formValue, assignMe){
  let formObject  = this.prepareIncomingFormObject('outgoingCall',formValue, assignMe);
  this.service.saveIncomingCall(formObject).then((response)=>{
    this.LoaderComponent = LoaderComponent;
    if(response['statusCode']===200){
     this.LoaderComponent  = "";
     this.savedTicketRefreshHistory()
    }
  })
 }

 submitInternalMemoForm(value){
   let memoObject ={
    message:value['memo'],
    ticketID:this.modifiedId,
    empID:this.empId,
    assignedEmpID:this.internalMemoEmpID
   }
   this.service.saveTicketInternalMemo(memoObject)
   .then((response)=>{
    this.LoaderComponent = LoaderComponent;
    if(response['statusCode']===200){
     this.LoaderComponent  = "";
     this.savedTicketRefreshHistory()

    }
   })
}

submitCloseTicketForm(value){
  let closeTicketObject = {
    reasonforClose:value['reasonForClose'],
    ticketID: this.modifiedId,
    empID:value['replyType']
  }
  this.service.saveClosedTicket(closeTicketObject) .then((response)=>{
    this.LoaderComponent = LoaderComponent;
    if(response['statusCode']===200){
     this.LoaderComponent  = "";
     this.closeViewTicketModal();
     this.savedTicketRefreshHistory();

    }
   })
}

 selectedOutgoingPhone(value){
  if(value && value!=""){
    let actualValue = value.split(' ');
    this.outGoingCallForm.controls['phoneNum'].setValue(actualValue[1]);
  }
 }

 selectedOutgoingVoiceCallType(value){
    if(value && value!=""){
      this.outgoingVoiceCallTypeValue = value.split(' ')[1].trim()
    }
 }

 selectedInternalMemoEmpID(id){
    if(id && id!=""){
      this.internalMemoEmpID = id.split(' ')[1].trim()
    }
 }

 hideFewNumbersInMobileNum(number){
  let countryCode = number.substring(0, number.indexOf('-') + 1)
  let callNumber = number.substring(number.indexOf('-') + 1)
  let replacedNumber = callNumber.slice(0).replace(/.(?=..)/g, 'x');
  return `${countryCode}${replacedNumber}`;
}

 prepareIncomingFormObject(type,object, assignMe){
  let day = moment()
   if(type==='incomingCall'){
    let incomingObject = {
      CallDiscussion: "I ("+this.loggedInUserName+") Received call from "+object['relationName']+" @"+object['phoneNum']+"..... "+object['callDiscussion'],
      CallResult: "417",
      CallType: 1,
      Calledon: day.format('DD-MMM-YYYY hh:mm:ss'),
      DisplayStatus: "2",
      EmpID: this.empId,
      PhoneNum: object['phoneNum'],
      RelationID: this.incomingCallRelationId,
      RelationName: object['relationName'],
      StaffCalled: this.empId,
      VoiceCallType: this.incomingVoiceCallTypeValue,
      ticketid: this.modifiedId,
      MarketingTicketStatus: object['MarketingTicketStatus'],
      isAssignedMe: assignMe,
    }
    return incomingObject;
   } else{
     let outGoingObject = {
      CallDiscussion: "I ("+this.loggedInUserName+") spoke to "+object['relationName']+" @"+object['phoneNum']+"..... "+object['callDiscussion'],
      CallResult: object['callResult'],
      CallType: 2,
      Calledon: day.format('DD-MMM-YYYY hh:mm:ss'),
      DisplayStatus: "2",
      EmpID: this.empId,
      PhoneNum: object['phoneNum'],
      RelationID: this.outGoingCallRelationId,
      RelationName: object['relationName'],
      StaffCalled: this.empId,
      VoiceCallType: this.outgoingVoiceCallTypeValue,
      ticketid: this.modifiedId,
      MarketingTicketStatus: object['MarketingTicketStatus'],
      isAssignedMe: assignMe,
     }
     return outGoingObject;
   }


 }
 selectedReplyType(value){
   if(value && value!=""){
    for(let object of this.replyTypeArray){
      if(object['ID']===value){
       if(object['TEXT']){
         this.closeTicketForm.controls['reasonForClose'].setValue(object['TEXT']);
         break;
       }
      }
    }
   }


 }
 selectedRelation(value){
   this.incomingCallRelationId = value.split(" ")[1];
   if(this.incomingCallRelationId!=""){
     this.LoaderComponent = LoaderComponent
     this.service.getRelationData(3,this.profileId,this.incomingCallRelationId).then((response)=>{
        if(response['statusCode'] === 200){
            this.LoaderComponent = "";
            if(response['result'] && response['result'][0].length > 0 && response['result'][0][0]['NAME']!=""){
              this.incomingCallForm.controls['relationName'].setValue(response['result'][0][0]['NAME'])
            } else{
              this.incomingCallForm.controls['relationName'].setValue("");
            }
        }
     })
   }
 }
 selectedOutGoingCallRelation(value){
  this.outGoingCallRelationId = value.split(" ")[1]
  if(this.outGoingCallRelationId!=""){
    this.LoaderComponent = LoaderComponent
    this.service.getRelationData(3,this.profileId,this.outGoingCallRelationId).then((response)=>{
       if(response['statusCode'] === 200){
           this.LoaderComponent = "";
           if(response['result'] && response['result'][0].length > 0  && response['result'][0][0]['NAME']!=""){
             this.outGoingCallForm.controls['relationName'].setValue(response['result'][0][0]['NAME'])
           } else{
             this.outGoingCallForm.controls['relationName'].setValue("");
           }
       }
    })
  }
 }
 selectedVoiceCallType(value){
   if(value && value!=""){
     let voiceType = value.split(' ')[1].trim()
     voiceType!=""?this.incomingVoiceCallTypeValue = voiceType:''

   }
 }
 verifyMobileNumber(){
   this.LoaderComponent = LoaderComponent;
   this.service.verifyMobileNumber(this.custId,3).then((response)=>{
     if(response['statusCode']===200){
      this.LoaderComponent = "";
      this.basicModal.show();
     } else{
      this.LoaderComponent = "";
       this.responseMessage = response['message'];
       this.successModal.show();
       setTimeout(() => {
        this.successModal.hide();
      }, 5000);
     }
   })
 }

 isSeletedYesOrNo(value){
   if(value==='Yes'){
    this.isSelectedToSendOTP = value;
   } else{
     this.isSelectedToSendOTP = value;
     this.otpForm.reset();
    this.basicModal.hide();
   }

 }

 getTicketHistoryTypeColour(type){
   if(type==='INCOMING'){
      return 'green'
   } else if(type==='OUT GOING'){
     return 'red'
   } else if(type==='InternalMemo'){
      return 'blue'
   }
 }

 getProfileTypeColour(type){
  if (type === 601) {
    return '#EC6227'
  } else if (type === 602) {
    return '#006980'
  } else if (type === 603) {
    return '#28009b'
  } else {
    return 'red'
  }
 }

 getModifiedProfile(profile,suscribedId){
  if (suscribedId === 601) {
    return profile + ' -R'
  } else if (suscribedId=== 602) {
    return profile + ' -A'
  } else if (suscribedId === 603) {
    return profile + ' -C'
  } else {
    return profile
  }
 }


 verifyMobileOtp(){
  this.LoaderComponent = LoaderComponent;
  if (this.otpForm.invalid) {
    this.LoaderComponent = '';
    return;
  }
  const otpCode =
    this.otpForm.value.otp1 +
    '' +
    this.otpForm.value.otp2 +
    '' +
    this.otpForm.value.otp3 +
    '' +
    this.otpForm.value.otp4 +
    '' +
    this.otpForm.value.otp5;
  const otpCodeNumber = Number(otpCode);
  this.service.verifyTicketMobileOTP(this.custId,otpCodeNumber).then((response)=>{
      if(response['statusCode']===200){
        this.LoaderComponent = ""
        this.basicModal.hide();
        this.responseMessage = response['message'];
        this.successModal.show();
        setTimeout(() => {
          this.successModal.hide();
        }, 5000);
      } else{
        this.LoaderComponent = "";
        this.responseMessage = response['message'];
        this.successModal.show();
        setTimeout(() => {
          this.successModal.hide();
        }, 5000);
      }
  })

 }

 viewOffers(id){
  window.open(`/paymentOffers;id=${id}`,'_blank');

 }

 createOffers(id){
  window.open(`/membership;id=${id}`,'_blank');
 }

 verifyEmail() {
  this.LoaderComponent = LoaderComponent;
  this.service.verifyTicketEmail(this.custId).then((response)=>{
    if(response['statusCode']===200){
      this.LoaderComponent = "";
      this.responseMessage = response['message'];
      this.successModal.show();
      setTimeout(() => {
        this.successModal.hide();
      }, 5000);
    } else{
      this.LoaderComponent = "";
    }
  })
 }

 closeOTPModal(){
   this.basicModal.hide();
   this.otpForm.reset();
 }

 closeViewTicketModal(){
   //this.isModalShow = false;

   this.closeTicketModal.emit(false)
   this.viewTicketModal.hide();
   this.changeTab(1)
 }
 resetReaminder(value){
  this.isRemainderActive = false;

 }

 navigateToProfileDetails(){
  window.open(`/paymentDetails;id=${this.basicTicketInformation['ProfileID']}`,'_blank');
 }

 omit_special_char_withNumbers_custom(event) {
  const charCode = event.which ? event.which : event.keyCode;
  var k;
  k = event.charCode; //         k = event.keyCode;  (Both can be used)
  if (/^[0-9\s]*$/.test(event.key)) {
    return true;
  } else {
    event.preventDefault();
    return (
      (k > 64 && k < 91) ||
      (k > 96 && k < 123) ||
      k == 8 ||
      k == 32 ||
      (k >= 48 && k <= 57)
    );
  }
}

onInputEntry(event, nextInput, previousInput, formName) {
  const input = event.target;
  const length = input.value.length;

  const charCode = event.inputType;
  if (charCode === 'deleteContentBackward') {
    previousInput != undefined ? previousInput.focus() : '';
  } else {
  }

  if (input.value.length >= input.maxLength) {
    input.value.length >= 1
      ? (input.value = input.value.slice(0, input.maxLength))
      : '';
    input.value = input.value.slice(0, 1);
    nextInput.focus();
    this.otpForm.get(formName).setValue(Number(input.value));
  }

  var k;
  k = event.charCode; //         k = event.keyCode;  (Both can be used)
  if (k === 8) {
  }
  if (/^[0-9\s]*$/.test(event.key)) {
    return true;
  } else {
    event.preventDefault();
    return (
      (k > 64 && k < 91) ||
      (k > 96 && k < 123) ||
      k == 8 ||
      k == 32 ||
      (k >= 48 && k <= 57) ||
      length > 1
    );
  }
}

onFocusInput(event) {
  const input = event.target;
  const length = input.value.length;

  const charCode = event.inputType;
  if (charCode === 'deleteContentBackward') {
  } else {
  }
}

lastInput(event, previousInput, formName) {
  const input = event.target;
  const charCode = event.inputType;
  if (charCode === 'deleteContentBackward') {
    previousInput.focus();
  } else {
  }
  if (input.value.length >= input.maxLength) {
    input.value.length >= 1
      ? (input.value = input.value.slice(0, input.maxLength))
      : '';
    input.value = input.value.slice(0, 1);
    this.otpForm.get(formName).setValue(Number(input.value));
  }
}


remainderChange(event){

}

savedTicketRefreshHistory(){

  this.service.getTicketInformation(this.modifiedId,'H').then((history)=>{
    this.LoaderComponent = LoaderComponent
    if(history['statusCode']===200){
      this.LoaderComponent = ""
      this.ticketHistoryList = [];
      this.ticketHistoryList = history['result'];
      this.changeTab(1);
    } else{
      this.LoaderComponent = "";

    }
  })

}

navigateToViewProfile(profileId) {
  window.open(`/viewProfile;id=${profileId}`, '_blank');

}

openEditViewPage(data,type){
  if(type!='' && data['Cust_ID']!=null){
    let selectedType
    switch(type.trim()){
      case 'CustomerPersonal':
        selectedType = 'educational'
        break;
      case 'Astro':
        selectedType = 'aestro'
        break;
      case 'Property':
        selectedType = 'property'
        break;
      case 'Profession':
        selectedType = 'educational'
       break;
      case 'Photo':
        selectedType = 'managePhoto'
        break;
      case 'HoroscopeImage':
        selectedType = 'aestro'
        break
      case 'Sibling':
        selectedType = 'sibling'
        break;
      case 'Parent':
        selectedType = 'parentDetails'
        break;

    }
    window.open(`/editViewDashBoard;id=${data['Cust_ID']};type=${selectedType}`,'_blank');


  }

}


}
